import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireSquad} from '../umpire-squad';

export interface UmpireComponentMatchList
  extends UmpireComponent<UmpireComponentTypeEnum.MATCH_LIST> {
  include_recently_ended: boolean;
  squad: UmpireSquad | null;
}
